import axios from '@lib/axios';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export interface UserInputs {
  name: string;
  email: string;
  role: string;
  active?: boolean;
}

export interface TData {
  name: string;
  email: string;
  role: string;
}

interface SaveUserProps {
  userId?: string;
	onSuccess?: (data: AxiosResponse) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useSaveUser = ({
  userId,
	onSuccess,
  onError
}: SaveUserProps) => {
  const queryClient = useQueryClient();
	const {
		isPending,
		isError,
		error,
		mutate: onSaveUser,
	} = useMutation({
		mutationFn: async (data: UserInputs) => {
      if (userId) 
        return axios.patch(`/users/${userId}`, data);
      return axios.post('/users', data);
		},
		onSuccess: (data) => {
      if (userId)
        queryClient.invalidateQueries({ queryKey: ['user', userId] });
      if (onSuccess)
        onSuccess(data);
    },
    onError
	});

	return { onSaveUser, isPending, isError, error };
};
